var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48342 4.99961C5.97301 5.23605 6.52072 5.50056 7.23287 5.50056C8.58904 5.50056 10.6986 3.92913 11 2.3577C10.5982 2.50056 9.6137 2.78627 8.89041 2.78627C8.16712 2.78627 7.38355 2.21484 7.08218 1.92913C6.78081 1.3577 5.75615 0.214844 4.06848 0.214844C2.3808 0.214844 1.75797 0.88151 1.65751 1.21484V5.78627C2.58498 5.01343 3.13561 4.76669 4.21916 4.64342C4.64545 4.59492 5.04067 4.78578 5.48342 4.99961ZM0.678084 0.643415C0.303588 0.643415 0 0.931233 0 1.28627V9.50056L1.35617 10.2148V1.28627C1.35617 0.931232 1.05258 0.643415 0.678084 0.643415Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleFlagIcon);
export default __webpack_public_path__ + "static/media/simple-flag-icon.898b65b06be6a8da304771ccbaab994c.svg";
export { ForwardRef as ReactComponent };